import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { alreadyLoggedUrl, newPasswordUrl } from 'utils';
import 'antd/dist/antd.css';

import keycloak from './Keycloak.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

keycloak.init({ onLoad: 'check-sso' }).then(authenticated => {
  console.log("window.location is : ",window.location);
  //const currentPage = window.location.hash.replace("#/", "",);
  const currentPage = window.location.href.split('/');
  let tempPage = currentPage[4];
  console.log("tempPage ", tempPage);
  keycloak.postInit({
    isAuthPages: (["login", "forgot-password"].includes(tempPage)),
    redirectToAlreadyLogged: () => {
      window.location.href = alreadyLoggedUrl;
      //window.location.reload();
    },
    redirectToNewPassword: () => {
      if (window.location.href == newPasswordUrl) return;
      window.location.href = newPasswordUrl;
      //window.location.reload();
    }
  });
  if (authenticated) {
    // first hook on logout event and redirect to login
    keycloak.onAuthLogout = function () {
      keycloak.redirectToLogin();
    };
    keycloak.loadReactDom(function (e) {
      // load React DOM
      //const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(
        <React.StrictMode>
          <Provider store={store}>
            <App />
          </Provider>
        </React.StrictMode>
      );
    });
  } else {
    // just redirect to the login page
    keycloak.redirectToLogin();
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
